$(document).ready(function () {
    const tableEl = $('#stock-receipts-table');
    if (!tableEl.length) return;

    const dataTable = tableEl.DataTable({
        processing: true,
        serverSide: true,
        pageLength: 25,
        searchDelay: 350,
        order: [],
        lengthMenu: [[10, 25, 50, 100], [10, 25, 50, 100]],
        ajax: {
            url: tableEl.data('url'),
            data: function (d) {
                const form = $('#stock-receipts-filters');
                if (form.length) {
                    form.serializeArray().forEach(function (field) {
                        if (d[field.name] === undefined) d[field.name] = field.value;
                        else if (Array.isArray(d[field.name])) d[field.name].push(field.value);
                        else d[field.name] = [d[field.name], field.value];
                    });
                }
            }
        },
        columns: [
            { data: 'id', name: 'id' },
            { data: 'receipt_date', name: 'receipt_date' },
            { data: 'supplier_name', name: 'supplier_name' },
            { data: 'items', name: 'items' },
            { data: 'amount', name: 'amount' },
            { data: 'actions', name: 'actions', orderable: false, searchable: false }
        ],
        language: window.dataTablesRussianLanguage
    });

    const form = $('#stock-receipts-filters');
    if (form.length) {
        form.on('submit', function (e) {
            e.preventDefault();
            dataTable.page('first').draw('page');
        });
        form.on('changed.bs.select change', 'select, input[type="date"]', function () { dataTable.page('first').draw('page'); });
        form.on('click', '.js-table-reset', function () { form[0].reset(); form.find('.selectpicker').selectpicker('refresh'); dataTable.search('').order([1, 'desc']).page('first').draw(); });
    }
});
